import React from 'react';
import MarketingDashboardPreview from './MarketingDashboardPreview';
import './MarketingAssets.css';

/**
 * Email / campaign composite — the real member dashboard home (not a invented grid).
 * Kicker for campaign copy + production Tracker, Goals, and E-Learning board.
 */
const MarketingEmailCompositePreview = () => (
    <div className="marketing-email-composite-v2">
        <p className="marketing-email-composite-v2__kicker">
            Inside the Oola Framework
        </p>
        <MarketingDashboardPreview
            production
            trackerTab="tracker"
            className="marketing-email-composite-v2__dashboard marketing-split--production"
        />
    </div>
);

export default MarketingEmailCompositePreview;
